declare const Reflect: any;
export type BgxParamType = 'param' | 'response' | 'body' | 'queryParams';

export const bgxHttpRESTParam: symbol = Symbol('BgxHttpRESTParam');

/**
 * Abstract implementation of the http param decorator
 * @internal
 */
export function BgxAbstractParam(
  type: BgxParamType,
  param?: string,
): (target: object, propertyKey: string | symbol, parameterIndex: number) => void {
  return function(target: object, propertyKey: string | symbol, parameterIndex: number): void {
    const parameters: { index: number; param: string; type: BgxParamType }[] =
      Reflect.getOwnMetadata(bgxHttpRESTParam, target, propertyKey) || [];
    parameters.push({
      index: parameterIndex,
      param,
      type,
    });
    Reflect.defineMetadata(bgxHttpRESTParam, parameters, target, propertyKey);
  };
}
